/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../../../../api/index';
import * as core from '../../../../../core';
import * as serializers from '../../../../index';

export const FileUpdateLabelsRequest: core.serialization.Schema<
    serializers.FileUpdateLabelsRequest.Raw,
    Omit<Truvity.FileUpdateLabelsRequest, 'idempotencyKey' | 'ifMatch'>
> = core.serialization.object({
    labels: core.serialization.record(core.serialization.string(), core.serialization.string()),
});

export declare namespace FileUpdateLabelsRequest {
    export interface Raw {
        labels: Record<string, string>;
    }
}
